import { colors, FadeOutAnimation, font, spacing } from '@chegg-ui/theme'
import styled, { css } from 'styled-components'
import { InfoTooltipContainerProps } from './types'
import { ANIMATION_FADEOUT_DELAY_SECONDS } from './constants'

export const InfoTooltipContainer = styled.div<InfoTooltipContainerProps>`
  display: flex;
  font-size: ${font.size.px14};
  font-weight: ${font.weight.medium};
  padding: ${spacing.px4} ${spacing.px8};
  line-height: ${font.lineHeight.xs};
  gap: ${spacing.px4};
  align-items: center;
  background-color: #44414e;
  color: ${colors.white};
  border-radius: 6px;
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'absolute')};
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : top)};
  right: ${({ right }) => right && (typeof right === 'number' ? `${right}px` : right)};
  left: ${({ left }) => left && (typeof left === 'number' ? `${left}px` : left)};

  ${({ autoDisappear }) =>
    autoDisappear &&
    css`
      animation: ${FadeOutAnimation({
        delay: ANIMATION_FADEOUT_DELAY_SECONDS,
      })};
    `}
`
